import { useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { Col, Row } from 'react-bootstrap';
import { BsCalendar, BsAward } from 'react-icons/bs';
import { BiTimeFive } from 'react-icons/bi';
import { Button, ContentCard, Label, ModalGeneric } from 'ypf-pas-general-ui-components';

import useToast from '../../../../hooks/useToast';
import { solicitante } from '../../../../security/constantsRols';
import { checkRol } from '../../../../security';
import { assignmentTypeEnum, statusEnum } from '../../../../utils/dataStatus';
import ConfirmAssignModal from '../../../../components/AssignProviderModals/ConfirmAssignModal';
import ErrorAssignModal from '../../../../components/AssignProviderModals/ErrorAssignModal';
import RequestsIcon from '../../../../components/RequestsIcon/RequestsIcon';
import MultipleServiceRequestModal from '../../../../components/MultipleServiceRequestModal/MultipleServiceRequestModal';
import { putAssignationProvider } from '../../../../adapters/requestServiceDetails/requestServiceDetailsAdapter';
import './Description.scss';
import { DetailRequest } from '../../../../utils/globalPropTypes';
import { firstUpperLetter } from '../../../../utils/globalFunctions';

import ReassignProvider from './ReassignProvider';

const Description = ({ details, setActiveTab }) => {
  const titleService = details?.servicio?.nombre;
  const description = details?.servicioDescripcion;
  const moreDescription = description?.length > 150;
  const typeAsignation = details?.tipoAsignacion?.nombre;
  const status = details?.estadoEnum;
  const responseDate = details?.pasoFechaRespuesta;
  const assignedProvider = details?.proveedorAsignado.nombre;
  const applicantName = details?.nombreSolicitante;
  const formattedName = firstUpperLetter(applicantName);
  const probableDate = details?.fechaProbableRealizacion

    .split('T')[0]
    .split('-')
    .reverse()
    .join('/');
  const requestDate = details?.fechaRespuesta.split('T')[0].split('-').reverse().join('/');
  const [showModalReassign, setShowModalReassign] = useState(false);
  const [showModalAssign, setShowModalAssign] = useState(false);
  const [showModalError, setShowModalError] = useState(false);
  const [showModalMultipleServiceRequest, setShowModalMultipleServiceRequest] = useState(false);
  const [providerData, setProviderData] = useState(null);
  const [errorEnum, setErrorEnum] = useState(null);
  const [message, setMessage] = useState('');
  const [isChecked, setIsChecked] = useState(null);
  const [truncateText, setTruncateText] = useState(false);
  const [showTable, setShowTable] = useState(false);
  const history = useHistory();
  const { setNewToast } = useToast();

  const viewProvider = status >= statusEnum.asignada;
  const viewDateRequest = status === statusEnum.enviada || status === statusEnum.cancelada;

  const assignProviderData = async () => {
    try {
      const response = await putAssignationProvider(
        providerData.idSolicitudServicio,
        providerData.idProveedor,
        providerData.proveedor,
        message.trim()
      );

      if (!response.redireccionEnum) {
        history.push('/');
        setNewToast({
          type: 'SUCCESS',
          message: `Se ha reasignado la solicitud N° ${response.numeroSolicitud}`
        });
      } else {
        setShowModalAssign(false);
        setMessage('');
        setErrorEnum(response?.redireccionEnum);
        setShowModalError(true);
      }
    } catch (error) {
      setShowModalAssign(false);
      setMessage('');
      setIsChecked(null);
      setNewToast({
        type: 'ERROR',
        message: error.message
      });
    }
  };

  const truncate = (text) => (
    <div>
      {!truncateText ? `${text?.substring(0, 150)}... ` : text}
      <button
        className="button_see_more"
        onClick={() => setTruncateText(!truncateText)}
        type="button"
      >
        {!truncateText ? 'VER MÁS' : 'VER MENOS'}
      </button>
    </div>
  );

  return (
    <div className="card-description">
      <ContentCard className="d-flex" mark="close" orientation="vertical">
        <Col className="col-border space-left" sm={7}>
          <section className="pt-4">
            <div className="subtitle-top pt-2"> Servicio</div>
            <h2 className="title-description">{titleService}</h2>
          </section>
          <section>
            <div className="subtitle-top">Descripción</div>
            <p className="description-text">
              {moreDescription ? truncate(description) : description}
            </p>
          </section>
          <Row className="d-flex justify-content-row">
            <Col sm={4}>
              <section className="pb-2">
                <div className="subtitle-top">Tipo de asignación</div>
                <p className="text-bold">{typeAsignation}</p>
              </section>
            </Col>

            {details?.grupo && (
              <Col sm={8}>
                <section className="pb-2">
                  <div className="subtitle-top-new">Tipo de solicitud</div>
                  <div className="d-flex">
                    <p className="text-bold-group">Grupales</p>
                    <div className="icon_multiple_service_request">
                      <RequestsIcon
                        color={details?.iconoSolicitud?.color}
                        letter={details?.iconoSolicitud?.letra || details?.numero[0]}
                        shape={details?.iconoSolicitud?.forma}
                      />
                    </div>
                    <div>
                      <Button
                        className="button-link"
                        label="Ver SDS relacionadas"
                        onClick={() => setShowModalMultipleServiceRequest(true)}
                        sizeIcon="27px"
                        type="button"
                        variant="link"
                        widthButton="175px"
                      />
                    </div>
                  </div>
                </section>
              </Col>
            )}
          </Row>
        </Col>
        <Col className="pt-1" sm={5}>
          {details?.tipoAsignacion?.id !== assignmentTypeEnum.Automatica && (
            <>
              <div className="col-border-rigth d-flex space-left pt-4">
                <Label
                  fullWidth={false}
                  icon={BsCalendar}
                  iconPosition="left"
                  label="Fecha de realización"
                  size="md"
                  sizeValue="lg"
                  value={probableDate}
                  variant="light"
                />
              </div>
              <div className="col-border-rigth d-flex space-left pt-4">
                <Label
                  fullWidth={false}
                  label="Solicitante"
                  size="md"
                  sizeValue="lg"
                  value={formattedName}
                  variant="light"
                />
              </div>
            </>
          )}

          <div className={` space-left pt-4 pb-4 ${responseDate ? 'styleField' : ''}`}>
            {viewDateRequest &&
              details?.tipoAsignacion?.id !== assignmentTypeEnum.Automatica &&
              !assignedProvider && (
                <div>
                  <Label
                    fullWidth={false}
                    icon={responseDate ? BiTimeFive : BsCalendar}
                    iconPosition="left"
                    label="Fecha de necesidad de respuesta"
                    size="md"
                    sizeValue="lg"
                    value={requestDate}
                    variant="light"
                  />
                </div>
              )}
            {viewProvider && assignedProvider && (
              <div className="d-flex">
                <Label
                  fullWidth={false}
                  icon={BsAward}
                  iconPosition="left"
                  label="Proveedor asignado"
                  size="md"
                  sizeValue="md"
                  value={`${assignedProvider} (${details?.numeroContrato})`}
                  variant="light"
                />
                {status === statusEnum.asignada && checkRol(solicitante) && (
                  <div className="content-button">
                    <Button
                      label="Reasignar"
                      onClick={() => setShowModalReassign(true)}
                      type="button"
                      variant="outline-danger"
                      widthButton="102px"
                    />
                  </div>
                )}
              </div>
            )}
          </div>
        </Col>
      </ContentCard>

      <ModalGeneric
        backdrop="static"
        infoModal
        onHide={async () => {
          setShowModalReassign(false);
          setShowTable(false);
          setIsChecked(null);
        }}
        primaryAction={() => {
          setShowModalReassign(false);
          setShowModalAssign(true);
          setShowTable(false);
          setIsChecked(null);
        }}
        primaryActionDisabled={!message.length || isChecked === null}
        primaryActionLabel={showTable ? 'Reasignar en solicitud duplicada' : 'Reasignar'}
        primaryActionVariant="danger"
        secondaryAction={() => {
          setShowModalReassign(false);
          setShowTable(false);
          setIsChecked(null);
        }}
        secondaryActionLabel="Salir"
        show={showModalReassign}
        size="xl"
        title="Reasignar solicitud de servicio"
      >
        <ReassignProvider
          idService={details?.servicio?.id}
          idsEventoPozo={details?.idsEventoPozo}
          isChecked={isChecked}
          message={message}
          numero={details?.numero}
          proveedorAsignado={details?.proveedorAsignado}
          providerData={providerData}
          setIsChecked={setIsChecked}
          setMessage={setMessage}
          setProviderData={setProviderData}
          setShowTable={setShowTable}
          showTable={showTable}
          tipoAsignacionEnum={details?.tipoAsignacion?.id}
          tipoUbicacion={details?.tipoUbicacion?.id}
          ubicationStr={details?.ubicacionStr}
        />
      </ModalGeneric>

      <ConfirmAssignModal
        assignProviderData={assignProviderData}
        numero={details?.numero}
        proveedor={providerData?.proveedor}
        setIsChecked={setIsChecked}
        setMessage={setMessage}
        setShowModalAssign={setShowModalAssign}
        showModalAssign={showModalAssign}
      />

      <ErrorAssignModal
        errorEnum={errorEnum}
        numero={details?.numero}
        proveedor={providerData?.proveedor}
        setActiveTab={setActiveTab}
        setIsChecked={setIsChecked}
        setProviderData={setProviderData}
        setShowModalError={setShowModalError}
        showModalError={showModalError}
      />
      <MultipleServiceRequestModal
        idSolicitudMultiple={details?.id}
        setShowModalMultipleServiceRequest={setShowModalMultipleServiceRequest}
        showModalMultipleServiceRequest={showModalMultipleServiceRequest}
      />
    </div>
  );
};

Description.propTypes = {
  details: DetailRequest,
  setActiveTab: PropTypes.func
};

Description.defaultProps = {
  details: {
    iconoSolicitud: {
      forma: 0,
      color: '#37A08C',
      letra: 'G'
    },
    grupo: false,
    id: 0,
    numero: '',
    ubicacionStr: '',
    tipoUbicacion: {
      id: 0,
      nombre: ''
    },
    unidadNegocio: {
      id: 0,
      nombre: ''
    },
    servicio: {
      id: 0,
      nombre: ''
    },
    fechaProbableRealizacion: '',
    fechaRespuesta: '',
    servicioDescripcion: '',
    estadoEnum: 0,
    tipoAsignacion: {
      id: 0,
      nombre: ''
    },
    proveedorAsignado: {
      id: 0,
      nombre: ''
    },
    proveedoresAceptados: 0,
    proveedoresRechazados: 0,
    proveedoresTotales: 0,
    pasoFechaRespuesta: false,
    nuevoMensaje: false
  },
  setActiveTab: () => {
    /* empty */
  }
};

export default Description;
